









































import { IMedia } from '@/interfaces/product'
import Vue from 'vue'
export default Vue.extend({
  name: 'SlideShowMedia',
  props: {
    media: {
      type: Object as () => IMedia,
      default: null
    }
  },
  methods: {
    openVideoModal (url: string, aspect: string) {
      this.$store.commit('video/OPEN_VIDEO_MODAL', { url, aspect })
    }

  }
})

/*
0, for pure image, dest_url for full resolution image
1, for video, dest_url for video url
2, redirect to product, dest_url for product id
3, redirect to url in "current page", dest_url for redirect url
4, redirect to url in "new page", dest_url for redirect url

type 3補充爲"使用現有網頁開啓連結"
新增type 4代表"使用新頁面開啓連結"
對於mobile app來說，因爲一律使用外部瀏覽器開啓連結，所以type 3/4沒有差別
*/

